import React, { useContext, useState } from 'react';
import c from 'classnames';
import { ApiAutocomplete } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { AddressTeaser } from '../../containers/types';
import DataContext from '../../contexts/DataContext';
import './style.scss';
import { API_URL, API_URL_OPTIONS } from '../../../../shared/config/constants';

interface Props {
  onSelect: (item?: AddressTeaser) => {}
}

const Autocomplete: React.FC<Props> = React.memo(({ onSelect }) => {
  const {
    address,
  } = useContext(DataContext);
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string>('');

  const classes = c({ 'not-placeholder': selected !== '' });

  return (
    <div className="Autocomplete form-item report-form-item">
      <ApiAutocomplete
        key={`item--${selected}`}
        defaultValue=""
        requestOptions={API_URL_OPTIONS}
        id="autocomplete"
        className={classes}
        endpoint={`${API_URL}/v1/reports/address/suggest`}
        placeholder={address ? address.weergavenaam : String(t('reports.stepper.location.placeholder'))}
        getSuggestionValue={(item: AddressTeaser) => item.weergavenaam}
        renderItem={(item: AddressTeaser) => (
          <div className="Autocomplete__item">
            {item.weergavenaam}
          </div>
        )}
        onSelectItem={(item: AddressTeaser) => {
          setSelected(item.weergavenaam);
          onSelect(item);
        }}
      />
      <div className="icon icon-after icon-search" />
    </div>
  );
});

export default Autocomplete;
